import { Loader2 } from 'lucide-react'
import type React from 'react'
import { Navigate } from 'react-router'

import { useProfile } from '@/features/auth/hooks/use-profile'

interface AdminRouteProps {
  children: React.ReactNode
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { profile, loading } = useProfile()

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-linear-to-br from-background to-card">
        <div className="flex items-center space-x-2">
          <Loader2 className="h-6 w-6 animate-spin" />
          <span>Loading...</span>
        </div>
      </div>
    )
  }

  if (profile?.role !== 'admin') {
    return <Navigate replace to="/settings" />
  }

  return <>{children}</>
}
